export const IdentifiersToYmGoalsIdMap = {
    '.header__logo--betcity': 'logo_bet',
    '.header__logo--championat': 'logo_champ',
    '.header__present-link': 'logo_ gift',
    '.cover__button': 'start',
    '.rules__button': 'play',
    '.header__ratings-button': 'rating',
    '.ratings__link-button': 'pick_up _bonus',
    '.result__link-button': 'pick_up _bonus',
    '.result__repeat-button': 'again',
    '.ratings__back-button': 'back'
};
